import { useGetContentListQuery } from '@api/api';
import { ContentRequest, EpiBlock } from '@api/types';
import {
  BlockContainer,
  BlockProperty,
  BlockWrapper,
  DataLoadingProgress,
  GenericError,
  Slider,
  SliderProps,
  Title,
} from '@components';
import { SwiperSlide } from 'swiper/react';

// TYPES
//-------
export type SlideshowBlockProps = SliderProps & {
  content?: EpiBlock[];
  title?: string;
  delay?: string;
};

// COMPONENTS
//------------

export const SlideshowBlock = ({ content, title, delay = '5000' }: SlideshowBlockProps) => {
  const sliderProps: SliderProps = {
    spaceBetween: 0,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: parseInt(delay),
    },
    parallax: true,
  };

  const references = content
    ?.map((x) => x?.contentLink?.id)
    .filter((x) => x !== undefined) as number[];
  const request: ContentRequest = { references, expand: '*' };
  const response = useGetContentListQuery(request);
  const { data, isLoading, isSuccess, isError } = response;

  return (
    <BlockContainer>
      <BlockProperty property='title'>
        <Title>{title}</Title>
      </BlockProperty>
      {isLoading && <DataLoadingProgress />}

      <BlockProperty property='content' contentArea>
        {isSuccess && data?.length !== 0 ? (
          <Slider {...sliderProps}>
            {data?.map((block) => {
              const id = block?.contentLink?.id;
              return id ? (
                <SwiperSlide key={id}>
                  <BlockWrapper blockData={block} disableEditPanel={true} />
                </SwiperSlide>
              ) : null;
            })}
          </Slider>
        ) : null}
      </BlockProperty>

      {isError && <GenericError />}
    </BlockContainer>
  );
};
